// extracted by css-extract-rspack-plugin
export default {"CompactCommentInputContainer":"CompactCommentButton-module__CompactCommentInputContainer__yAeafu7"};